const NAMESPACE = 'TRIP_SUMMARY_DATA';

const SET_DEPART_TRIP_ID = `${NAMESPACE}/SET_DEPART_TRIP_ID`;
const SET_RETURN_TRIP_ID = `${NAMESPACE}/SET_RETURN_TRIP_ID`;
const SET_TRAVELER_INFO = `${NAMESPACE}/SET_TRAVELER_INFO`;
const SET_FARE_CLASS = `${NAMESPACE}/SET_FARE_CLASS`;
const RESET_TRAVELER_INFO = `${NAMESPACE}/RESET_TRAVELER_INFO`;
const REMOVE_TRIP_IDS = `${NAMESPACE}/REMOVE_TRIP_IDS`;

export {
    REMOVE_TRIP_IDS,
    RESET_TRAVELER_INFO,
    SET_DEPART_TRIP_ID,
    SET_FARE_CLASS,
    SET_RETURN_TRIP_ID,
    SET_TRAVELER_INFO,
};

export default NAMESPACE;
